import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/layout/AppLayout';
import { RequireAuth } from '@/layout/RequireAuth';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { LiveScreen } from '@/pages/LiveScreen';
import { Employees } from '@/pages/Employees';
import { AuditSignals } from '@/pages/AuditSignals';
import { Orders } from '@/pages/Orders';
import { UserOrders } from '@/pages/UserOrders';
import { SymbolsPage } from '@/pages/Symbols';
import { SessionConfig } from '@/pages/SessionConfig';
import { TradingGroups } from '@/pages/TradingGroups';
import { RiskConfig } from '@/pages/RiskConfig';
import { AssessmentConfig } from '@/pages/AssessmentConfig';
import { AssessmentRecords } from '@/pages/AssessmentRecords';
import { CtidsPage } from '@/pages/Ctids';
import { AuditLog } from '@/pages/AuditLog';
import { AlertsCenter } from '@/pages/AlertsCenter';
import { Reports } from '@/pages/Reports';
import { ProfitShare } from '@/pages/ProfitShare';
import { PlatformPnl } from '@/pages/PlatformPnl';
import { Settings } from '@/pages/Settings';
import { InviteCodes } from '@/pages/InviteCodes';
import { AppVersion } from '@/pages/AppVersion';
import { NotFound } from '@/pages/NotFound';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    errorElement: <NotFound />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'live', element: <LiveScreen /> },
      { path: 'demo', element: <Navigate to="/dashboard" replace /> },
      { path: 'employees', element: <Employees /> },
      { path: 'signals', element: <AuditSignals /> },
      { path: 'orders', element: <Orders /> },
      { path: 'user-orders', element: <UserOrders /> },
      { path: 'symbols', element: <SymbolsPage /> },
      { path: 'session', element: <SessionConfig /> },
      { path: 'trading-groups', element: <TradingGroups /> },
      { path: 'risk', element: <RiskConfig /> },
      { path: 'assessment', element: <AssessmentRecords /> },
      { path: 'assessment-config', element: <AssessmentConfig /> },
      { path: 'ctids', element: <CtidsPage /> },
      { path: 'audit-log', element: <AuditLog /> },
      { path: 'alerts', element: <AlertsCenter /> },
      { path: 'reports', element: <Reports /> },
      { path: 'profit-share', element: <ProfitShare /> },
      { path: 'platform-pnl', element: <PlatformPnl /> },
      { path: 'invite-codes', element: <InviteCodes /> },
      { path: 'app-version', element: <AppVersion /> },
      { path: 'settings', element: <Settings /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
